//  -----------------------------------------操作类----------------------------------------

// 节目发布类型
const PROGRAM_TYPE = {
  QUICK: 0, // 快速发布
  TEMPLATE: 1, // 模板发布
  CUSTOM: 2, // 自定义发布
};
const STATUS = {
  PENDING: 0,
  SUCCESS: 1,
  FAIL: 2,
};
// 选择类型
const CHOOSETYPE = {
  RADIO: 0, // 单选
  CHECKBOX: 1, // 多选
};

const RULERSTATUE = {
  CLOSE: 0,
  OPEN: 1,
  OPEN_RULER_LINE: 2,
  OPEN_PAGE_LINE: 3,
};

//  -----------------------------------------样式类----------------------------------------
// 页面列表样式相关参数
const PAGELIST_PARAMS = {
  PAGELIST_DEFAULT_WIDTH: 260, // 默认宽度
  PAGELIST_MIN_WIDTH: 30, // 最小宽度
  PAGELIST_MAX_WIDTH: 500, // 最大支持宽度
  PAGELIST_PAGE_GAP: 17 + 21 + 24, // 展示节目和页面列表之间的差值
  PAGLIST_PAGE_MIN_WIDTH: 130, // 展示的节目最小宽度
};
// 素材选择样式相关参数
const MATERIALSET_PARAMS = {
  FOLD_WIDTH: 48,
  // FOLD_WIDTH: 56,
  UNFOLD_LOCK_WIDTH: 48 + 240,
  // UNFOLD_LOCK_WIDTH: 56 + 272,
  UNFOLD_UNLOCK_WIDTH: 48,
  // UNFOLD_UNLOCK_WIDTH: 56,
};
// 操作栏样式相关参数
const WINDOWTOOL_PARAMS = {
  HEIGHT: 68,
  LEFTWIDTH: 561, // 左侧图标宽度
  SHOWSMALL: 1026 + 1, // 小图模式 2.1 lileijing工说都显示无字体
  SHOWSMALL_ZN: 850,
};
// 右侧配置样式相关参数
const PROP_PARAMS = {
  WIDTH: 280,
};
//  -----------------------------------------参数映射----------------------------------------

const SCREEN_SIZE = {
  horizontal: "16:9",
  vertical: "9:16",
};

const MATERIAL_SIZE_TRANS = {
  totalNum: "totalMaterialSize",
  usedNum: "usedMaterialSize",
  unUsedNum: "unUsedMaterialSize",
};

const ICONMAP = {
  "1920*1080": "ic-landscape_screen_stroke",
  "1080*1920": "ic-vertical_screen_stroke",
  selfDefine: "ic-icon_resolution_selfDefine",
  none: "ic-no_animate",
  null: "ic-no_animate",
  ball: "ic-Tree_balloon",
  leaf: "ic-Tree_leaf",
  snow: "ic-snow_wght2",
  pater: "ic-Tree_pape",
  gradient: "gradual_change",
};

const MATERIAL_SPACE_COLOR = {
  picture: "#4D69F4",
  video: "#FF802B",
  audio: "#42A7FF",
  other: "#34D987",
};
const MATERIAL_SPACE_ICON = {
  // 'picture': require('@/FocSign/assets/img/home/material_picture.png'),
  // 'video': require('@/FocSign/assets/img/home/material_vedio.png'),
  // 'audio': require('@/FocSign/assets/img/home/material_music.png'),
  // 'other': require('@/FocSign/assets/img/home/material_others.png')
};
const DATA_FORMATE = {
  1: "hh:mm A",
  2: "hh:mm",
  // 2: "HH:mm",
  3: "HH:mm dddd",
  4: "YYYY-MM-DD",
  5: "MM-DD-YYYY",
  6: "DD-MM-YYYY",
  7: "YYYY/MM/DD",
  8: "MM/DD/YYYY",
  9: "DD/MM/YYYY",
  10: "MM/DD",
};
// 本地使用设备类型
const DEVICE_TYPE = {
  INFORMATION_PUBLISH: "ad", // 信息发布设备
  INTERACTIVE_PLATE: "flat", // 交互平板
  ELECTRONIC_CLASS: "ecc", // 电子班牌设备
  SCREEN_CONTROLLER: "led", // 屏幕控制器
};

// 服务端mode转换MAP
const DEVICE_TYPE_MODE_MAP = {
  [DEVICE_TYPE.INFORMATION_PUBLISH]: "InfoRelease",
  [DEVICE_TYPE.INTERACTIVE_PLATE]: "InteractiveTablet",
  [DEVICE_TYPE.ELECTRONIC_CLASS]: "ElectronicClassCard",
  [DEVICE_TYPE.SCREEN_CONTROLLER]: "ScreenControl",
};
// 设备类型转换服务端mode MAP
const DEVICE_TYPE_MAP = {
  InfoRelease: "ad",
  InteractiveTablet: "flat",
  ElectronicClassCard: "ecc",
  ScreenControl: "led",
};
// 服务端设备类型DeviceCategory转换MAP
const ECC_DEVICE_TYPE = {
  [DEVICE_TYPE.INFORMATION_PUBLISH]: "focSignDevice",
  [DEVICE_TYPE.INTERACTIVE_PLATE]: "interactiveTablet",
  [DEVICE_TYPE.ELECTRONIC_CLASS]: "focSignDevice",
  [DEVICE_TYPE.SCREEN_CONTROLLER]: "screenControl",
};

const ECC_TYPE_MAP = {
  SPropaganda: 1,
  SNews: 2,
  SNotice: 3,
  SPhoto: 4,
  SVideo: 5,
};
const SUB_DEVICECATEGORY_QUICK = {
  [DEVICE_TYPE.ELECTRONIC_CLASS]: "1802",
  [DEVICE_TYPE.INFORMATION_PUBLISH]: "1801",
};

// 布局模版游离的窗口
const LAYOUT_FREE_WINDOWS = [
  "clock",
  "call",
  "character",
  "countdown",
  "hyperlinkBtn",
  "weather",
  "RSS",
  "signalSource",
];

// 支持混合类型的集合
const IS_SUPPORT_HYBRID_TYPES = ["picture", "video", "pdf", "ppt", "doc", "excel", "document", "realStream"]

// 支持的文档类型
const DOCUMENT_TYPES = ["pdf", "ppt", "doc", "excel", "document"]

// 预设颜色值
const PREDEFINE_COLORS = [
  "#56C1FF",
  "#00A2FF",
  "#0076BA",
  "#004D80",
  "#73FDEA",
  "#16E7CF",
  "#00AB8E",
  "#006C65",
  "#88FA4E",
  "#60D836",
  "#1DB100",
  "#017100",
  "#FFF056",
  "#FFD932",
  "#FEAE00",
  "#F27200",
  "#FF968D",
  "#FF644E",
  "#EF321E",
  "#B51700",
  "#FF95CA",
  "#FF42A1",
  "#D41876",
  "#970E53",
  "#FFFFFF",
  "#D5D5D5",
  "#929292",
  "#5E5E5E",
  "#000000",
]

export default {
  PAGELIST_PARAMS,
  PROGRAM_TYPE,
  MATERIALSET_PARAMS,
  WINDOWTOOL_PARAMS,
  PROP_PARAMS,
  STATUS,
  CHOOSETYPE,
  SCREEN_SIZE,
  MATERIAL_SIZE_TRANS,
  ICONMAP,
  MATERIAL_SPACE_COLOR,
  MATERIAL_SPACE_ICON,
  RULERSTATUE,
  DATA_FORMATE,
  ECC_DEVICE_TYPE,
  ECC_TYPE_MAP,
  SUB_DEVICECATEGORY_QUICK,
  DEVICE_TYPE,
  DEVICE_TYPE_MODE_MAP,
  DEVICE_TYPE_MAP,
  LAYOUT_FREE_WINDOWS,
  IS_SUPPORT_HYBRID_TYPES,
  DOCUMENT_TYPES,
  PREDEFINE_COLORS,
};
